// Excel kişi listeleri servisi (server /api/contacts). pid oturumdan alınır, gönderilmez.
import axios from 'axios';
import { API_ADDRESS, get, post } from './api';

export function getContactLists(key = 'contactList') {
	return get('/contacts/lists', { key }).then((data) => (data && data.lists) || []);
}

// Dosya FormData ile değil ham body olarak gider; server tarafında ayrı thread'de parse edilir.
// replace: true iken aynı key'deki önceki listeler silinir. name verilmezse dosya adı kullanılır.
export function uploadContactList(file, key = 'contactList', replace, name) {
	return axios({
		method: 'post',
		url: `${API_ADDRESS}/contacts/lists/upload`,
		params: { key, name: name || file.name, replace: replace ? 1 : undefined },
		data: file,
		headers: { 'Content-Type': 'application/octet-stream' },
		withCredentials: true,
	}).then((resp) => resp.data);
}

export function deleteContactList(id) {
	return post(`/contacts/lists/${id}/delete`, {}).then((resp) => resp.data);
}

// Tek sayfa: { data, next_cursor }
export function getContactListPage(id, params) {
	return get(`/contacts/lists/${id}/items`, params).then((data) => {
		if (!data || !data.success) throw Error((data && data.error) || 'contacts error');
		return data;
	});
}

// Listenin tüm kişileri (gönderim için), 5000'lik sayfalarla.
export async function getContactListItems(id, params) {
	let list = [];
	let cursor;
	do {
		const page = await getContactListPage(id, { ...params, cursor, limit: 5000 });
		list = list.concat(page.data);
		cursor = page.next_cursor;
	} while (cursor);
	return list;
}

// Sadece parse eder, kaydetmez: { success, rows: [{ Phone, Name, Label, ... }] }
export function parseContactFile(file) {
	return axios({
		method: 'post',
		url: `${API_ADDRESS}/contacts/parse`,
		data: file,
		headers: { 'Content-Type': 'application/octet-stream' },
		withCredentials: true,
	}).then((resp) => resp.data);
}

// Gönderim ekranları için liste özetleri eski dump şeklinde: { _id, filename, date, count }.
// Kişiler (data) liste seçildiğinde getContactListItems ile ayrıca yüklenir.
export function getExcelLists(key = 'contactList') {
	return getContactLists(key).then((lists) =>
		lists.map((it) => ({ _id: String(it.id), filename: it.name, date: it.created_at, count: it.row_count }))
	);
}
